function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStandardSubscription = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 250 250",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M89.2 30 30.5 89.24 91.02 150l59.48-59.28z",
  style: {
    fill: "#d8e3fd"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m158.2 100-58.7 59.24L160.02 220l59.48-59.28z",
  style: {
    fill: "#fff"
  }
}));
export { SvgStandardSubscription as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNTAgMjUwIj48ZGVmcz4KPHN0eWxlPi5kaWFtb25kLTF7ZmlsbDojZDhlM2ZkO30uZGlhbW9uZC0ye2ZpbGw6I2ZmZjt9PC9zdHlsZT4KPC9kZWZzPgo8cG9seWdvbiBjbGFzcz0iZGlhbW9uZC0xIiBwb2ludHM9Ijg5LjIgMzAgMzAuNSA4OS4yNCA5MS4wMiAxNTAgMTUwLjUgOTAuNzIgODkuMiAzMCIvPgo8cG9seWdvbiBjbGFzcz0iZGlhbW9uZC0yIiBwb2ludHM9IjE1OC4yIDEwMCA5OS41IDE1OS4yNCAxNjAuMDIgMjIwIDIxOS41IDE2MC43MiAxNTguMiAxMDAiLz48L3N2Zz4=";